import React from "react";

const IconMail = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 9.911 7.63"
    >
      <path
        id="svgexport-19"
        d="M3,6.421,6.736,8.912a.947.947,0,0,0,1.051,0l3.736-2.491M3.947,11.63h6.63a.947.947,0,0,0,.947-.947V5.947A.947.947,0,0,0,10.577,5H3.947A.947.947,0,0,0,3,5.947v4.736a.947.947,0,0,0,.947.947Z"
        transform="translate(-2.307 -4.5)"
        fill="none"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1"
      />
    </svg>
  );
};

export default IconMail;
